/**
 * Refuses PostgREST requests whose filters carry the string "undefined"
 * (`organization_id=eq.undefined`), before they leave the browser.
 *
 * Such a request means a query ran before its id was known: the org was still
 * resolving after sign-in, or a manual refetch() skipped `enabled`. Postgres
 * answers 400 (invalid uuid) and the page shows "no data" as if the company
 * were empty. Failing locally keeps the request off the wire, makes the query
 * error (TanStack Query retries it), and names the culprit in the console.
 */
const UNDEFINED_FILTER = /[?&][^=&]+=(?:[a-z]+\.)?undefined(?:&|$)/;

export function hasUndefinedFilter(url: string): boolean {
  const queryStart = url.indexOf("?");
  if (queryStart === -1 || !url.includes("/rest/v1/")) return false;
  return UNDEFINED_FILTER.test(url.slice(queryStart));
}

export function guardUndefinedFilters(inner: typeof fetch): typeof fetch {
  return (input, init) => {
    const url = typeof input === "string" ? input : input instanceof URL ? input.href : input.url;
    if (hasUndefinedFilter(url)) {
      const path = url.slice(url.indexOf("/rest/v1/"));
      console.error(`[supabase] refused a request with an undefined filter: ${path}`);
      return Promise.reject(new Error(`Request refused: undefined filter value (${path})`));
    }
    return inner(input, init);
  };
}
